import { memo, useEffect, useState } from "react";
import ProfilesByResourceType from "../dictionaries/ProfilesByResourceType";
import CodeEntry from "./CodeEntry";
import StringEntry from "./StringEntry";

const ProfileEntry = memo(({ resourceType, startingValue, setResourceState, elementName }) => {
  const profileDictionary = ProfilesByResourceType[resourceType];
  let startingProfile = { "name": startingValue || "", "url": startingValue || "" }
  let startingEnterValueState = true;
  let profileNames;
  if (profileDictionary) {
    profileNames = Object.keys(profileDictionary);
    for (const key in profileDictionary) {
      if (profileDictionary[key].url === startingValue) {
        startingProfile.name = key;
        startingEnterValueState = false;
      }
    }
  }
  if (!startingValue) {
    startingEnterValueState = false;
  }
  const [profileState, setProfileState] = useState(JSON.parse(JSON.stringify(startingProfile || null)));
  const [enterValueState, setEnterValueState] = useState(startingEnterValueState);

  useEffect((() => {
    if (profileState.name) {
      let newProfileString = profileState.name;
      if (profileDictionary) {
        for (const key in profileDictionary) {
          if (key === newProfileString) {
            newProfileString = profileDictionary[key].url;
          }
        }
      }
      if (newProfileString === "Enter a different value.") {
        newProfileString = "";
        setEnterValueState(true);
      }
      setResourceState(prevState => { return { ...prevState, [elementName]: newProfileString } });
    } else {
      setResourceState(prevState => { return { ...prevState, [elementName]: "" } });
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }), [profileState?.name]);

  if (profileNames && !enterValueState) {
    return <CodeEntry elementName='name' fieldLabel='Profile Name or URL'
      startingValue={profileState.name} setResourceState={setProfileState} dataEntryStyle="dropdown"
      allowedValues={profileNames} enableCreation={true} />
  }
  return <StringEntry elementName='name' fieldLabel='Profile Name or URL'
    startingValue={profileState.name !== "Enter a different value." ? profileState.name : ""}
    setResourceState={setProfileState} />
});

export default ProfileEntry;